import React, { useEffect } from "react";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import LeaderBoardResults from "../../components/leaderBoard/LeaderBoardResults";
import StudentPosition from "../../components/leaderBoard/StudentPosition";
import { useGetAssignmentMarksQuery } from "../../features/assignments/assignemntsApi";
import { useGetQuizMarksQuery } from "../../features/quizzes/quizzesApi";
import { useGetUsersQuery } from "../../features/users/usersApi";
import getUsersPosition from "../../utils/getUsersPosition";

export default function LeaderBoard() {
  const { data: users } = useGetUsersQuery();
  const { data: assignmentsMarks } = useGetAssignmentMarksQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const {
    data: quizMarks,
    isLoading,
    isError,
    error,
  } = useGetQuizMarksQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const usersPosition = getUsersPosition(users, quizMarks, assignmentsMarks);
  useEffect(() => {
    document.title = "LeaderBoard";
  });
  return (
    <>
      <Navbar />
      <Container>
        <StudentPosition usersPosition={usersPosition} />
        <LeaderBoardResults
          usersPosition={usersPosition}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </Container>
    </>
  );
}
